import React from 'react';
import styled, {ThemeProps} from 'styled-components';

import {Theme} from '../theme/types';

const SearchIconSvg = styled.svg(
  props => `
  fill: ${props.theme.colors.grey.grey50};
  width: ${props.width || '1.5rem'};
  height: ${props.height || '1.5rem'};
`,
);

const SearchInputIcon = (
  // props?: Partial<ThemeProps<Theme>>
  /**
   * the above comment needs to be included with all valid css props
   * 🐨 props should be any valid css prop.
   */

  props?: any,
) => {
  return (
    <SearchIconSvg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <title>search</title>
      <path d="M31.179 28.825l-8.705-8.705c4.139-5.441 3.084-13.207-2.357-17.347s-13.207-3.084-17.347 2.357c-4.139 5.441-3.084 13.207 2.357 17.347 4.429 3.369 10.561 3.369 14.989 0l8.705 8.705c0.656 0.64 1.702 0.64 2.357 0v0c0.65-0.651 0.65-1.706 0-2.357zM3.667 12.667v0c0-4.971 4.029-9 9-9s9 4.029 9 9c0 4.971-4.029 9-9 9v0c-4.968-0.006-8.994-4.032-9-9z"></path>
    </SearchIconSvg>
  );
};

export default SearchInputIcon;
